module.exports = __webpack_public_path__ + "img/single-neutral-actions-view.8a7afb63.svg";